module.exports = __webpack_public_path__ + "static/media/check.a6eaed1e.svg";